import { paths } from 'src/routes/paths';
import { CONFIG } from 'src/config-global';
import { SvgColor } from 'src/components/svg-color';
import { title } from 'process';

// ----------------------------------------------------------------------

const icon = (name: string, folder: string) => (
  <SvgColor src={`${CONFIG.assetsDir}/assets/icons/${folder}/${name}.svg`} />
);

const ICONS = {
  analytics: icon('ic-analytics', 'navbar'),
  xero: icon('xero-logo', 'brands'),
  nhs: icon('ic-brands-nhs', 'brands'),
  chart: icon('ic-extra-chart', 'components'),
  user: icon('ic-user', 'navbar'),
  kanban: icon('ic-kanban', 'navbar'),
  label: icon('ic-label', 'navbar'),
  invoice: icon('ic-invoice', 'navbar'),
  dashboard: icon('ic-dashboard', 'navbar'),
  job: icon('ic-job', 'navbar'),
  pms: icon('ic-course', 'navbar'),
};

// ----------------------------------------------------------------------

export function getNavData(userRoles: string[]) {
  const xeroRoles = ['myworkfin.xero.admin', 'myworkfin.xero.manager'];
  const managementRoles = ['myworkfin.user.admin'];
  const workFinManagmentRoles = ['myworkfin.managment.admin'];
  const compassRoles = ['myworkfin.compass.admin'];
  const pmsAdminRoles = ['myworkfin.pms.admin'];

  const hasManagementAccess = userRoles.some((role) => managementRoles.includes(role));
  const hasWorkFinManagmentAccess = userRoles.some((role) => workFinManagmentRoles.includes(role));
  const hasXeroAccess = userRoles.some((role) => xeroRoles.includes(role));
  const hasCompassAccess = userRoles.some((role) => compassRoles.includes(role));
  const hasPmsAdminAccess = userRoles.some((role) => pmsAdminRoles.includes(role));

  return [
    {
      subheader: 'Overview',
      items: [{ title: 'Home', path: paths.dashboard.root, icon: ICONS.dashboard }],
    },
    {
      subheader: 'Reports',
      items: [
        {
          title: 'Reports',
          path: paths.reports.viewer,
          icon: ICONS.analytics,
          children: [],
        },
      ],
    },
    ...(hasXeroAccess
      ? [
        {
          subheader: 'Connections',
          items: [
            {
              title: 'Xero',
              path: paths.xero.root,
              icon: ICONS.invoice,
              children: [
                {
                  title: 'List',
                  path: paths.xero.integrations,
                },
              ],
            },
          ],
        },
      ]
      : []),

    ...(hasXeroAccess
      ? [
        {
          subheader: 'COA',
          items: [
            {
              title: 'CoA Categories',
              path: paths.coa.root,
              icon: ICONS.label
            },
          ],
        },
      ]
      : []),

    ...(hasPmsAdminAccess
      ? [
        {
          subheader: 'Practice Management Systems',
          items: [
            {
              title: 'PMS Systems',
              path: paths.pms.root,
              icon: ICONS.pms,
              children: [
                {
                  title: 'SOE Exact',
                  path: paths.pms.soe.root,
                },
              ]
            },
          ],
        },
      ]
      : []),

    ...(hasCompassAccess
      ? [
        {
          subheader: 'Compass',
          items: [
            {
              title: 'Compass',
              path: paths.compass.root,
              icon: ICONS.nhs,
              children: [
                {
                  title: 'List',
                  path: paths.compass.list,
                },
              ],
            },
          ],
        },
      ]
      : []),

    ...(hasManagementAccess
      ? [
        {
          subheader: 'Management',
          items: [
            // Conditionally include 'Users' item based on roles
            ...(userRoles.includes('myworkfin.user.admin')
              ? [
                {
                  title: 'Users',
                  path: paths.users.root,
                  icon: ICONS.user,
                  children: [
                    { title: 'List', path: paths.users.root },
                    { title: 'Create', path: paths.users.create },
                  ],
                },
              ]
              : []),
            // Include other management items here
          ],
        },
      ]
      : []),
    ...(hasWorkFinManagmentAccess
      ? [
        {
          subheader: 'WorkFin Management',
          items: [
            // Include WorkFin Management items here
            {
              title: 'Tenants',
              path: paths.management.tenants.root,
              icon: ICONS.job,
              children: [
                { title: 'List', path: paths.management.tenants.root },
                { title: 'Create', path: paths.management.tenants.create },
              ],
            },
            {
              title: 'WorkFin Users',
              path: paths.management.users.root,
              icon: ICONS.user,
              children: [
                { title: 'List', path: paths.management.users.root },
                { title: 'Create', path: paths.management.users.create },
              ],
            },
          ],
        },
      ]
      : []),
  ];
}
